import {
    TBaseAndSupportDecompressed,
    TBaseAndSupport,
} from "@ts/common-types";

export const mapBaseDataWithSupportingData = async ({
    baseData,
    supportingData,
}: {
    baseData: TBaseAndSupportDecompressed | TBaseAndSupport;
    supportingData: TBaseAndSupportDecompressed | TBaseAndSupport;
}) => {
    const mergedData = [];
    const processedKeys = new Set<string>();

    // First, iterate over baseData and merge with supportingData
    for (const [key, value] of Object.entries(baseData)) {
        processedKeys.add(key);
        mergedData.push({
            ...value,
            ...(supportingData as Record<string, any>)[key],
        });
    }

    // Then, add any items from supportingData that don't exist in baseData, only if supportingData exists
    if (supportingData && Object.keys(supportingData).length > 0) {
        for (const [key, value] of Object.entries(supportingData)) {
            if (!processedKeys.has(key)) {
                mergedData.push(value);
            }
        }
    }

    return mergedData;
};

onmessage = async(event) => postMessage(await mapBaseDataWithSupportingData(event.data));
